import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

interface ColumnProps {
  wide?: boolean;
}

export const Column = styled.div<ColumnProps>`
  flex: 0 1 auto;
  
  ${({ wide }) =>
    wide &&
    css` 
    width: 97%;
    `}

  &.grow {
    flex-grow: 1;
  }

  &.no-shrink {
    flex-shrink: 0;
  }

  &.min-width-fix {
    min-width: 0;
  }

  &.overflow-scroll {
    overflow: auto;
  }

  &.overflow-hidden {
    overflow: hidden;
  }

  &.giftCardListColumn {
    width: 100%;
  }

  &.align-right {
    text-align: right;
  }

  &.align-right-md {
    ${theme.screens.Md} {
      text-align: right;
    }
  }

  &.fade-cut {
    overflow: hidden;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: 100px;
      background: linear-gradient(to right, transparent, #fff);
    }
  }

  &.inline {
    display: flex;
  }

  &.gap-1 {
    gap: ${size(1)};
  }

  &.center {
    align-items: center;

    ${theme.screens.LtSm} {
      align-items: flex-end;
    }
  }
`;

export const Columns = styled.div`
  display: flex;
  width: 100%;

  &.valign-middle {
    align-items: center;
  }

  &.valign-bottom {
    align-items: flex-end;
  }

  &.align-center {
    justify-content: center;
  }

  &.width-auto {
    width: auto;
  }

  &.wrap {
    flex-wrap: wrap;
  }

  &.space-half {
    & > ${Column} {
      padding-left: ${size(0.25)};
      padding-right: ${size(0.25)};
    }
  }

  &.space-1 {
    & > ${Column} {
      padding-left: ${size(0.5)};
      padding-right: ${size(0.5)};
    }
  }

  &.space-2 {
    & > ${Column} {
      padding-left: ${size(1)};
      padding-right: ${size(1)};
    }
  }

  &.space-3 {
    & > ${Column} {
      padding-left: ${size(1.5)};
      padding-right: ${size(1.5)};
    }
  }
  &.space-4 {
    & > ${Column} {
      padding-left: ${size(2.5)};
      padding-right: ${size(2.5)};
    }
  }

  &.space-r-half {
    & > ${Column} {
      padding-right: ${size(0.5)};
    }
  }

  &.space-r-1 {
    & > ${Column} {
      padding-right: ${size(1)};
    }
  }

  &.space-r-2 {
    & > ${Column} {
      padding-right: ${size(2)};
    }
  }

  &.space-r-3 {
    & > ${Column} {
      padding-right: ${size(3)};
    }
  }

  &.spacebtw-center {
    align-items: center;
    justify-content: space-between;
  }

  &.gap-1 {
    gap: ${size(1)};
  }

  &.gap-2 {
    gap: ${size(2)};
  }

  &.space-half,
  &.space-1,
  &.space-2,
  &.space-3,
  &.space-r-half,
  &.space-r-1,
  &.space-r-2,
  &.space-r-3 {
    & > ${Column} {
      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }

  &.fixed-layout {
    display: table;
    table-layout: fixed;
    height: 1px;

    & > * {
      display: table-cell;
    }
  }

  ${theme.screens.LtMd} {
    &.collapse-lt-md {
      display: block;
      height: auto;

      & > ${Column} {
        display: block;
        padding-left: 0;
        padding-right: 0;
      }
      & > ${Column} + ${Column} {
        padding-top: ${size(2)};
      }
    }
  }
`;
